__turbopack_context__.v({
  "root": "UnorderedList-module__JhDjTW__root",
});
